export default function UserGreating() {
  return <h1>UserGreating</h1>;
}
